import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIcCheck = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	fill: "none",
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		stroke: "#3B444C",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.5,
		d: "m20.25 6.75-10.5 10.5L4.5 12",
		vectorEffect: "non-scaling-stroke"
	})
});
export default SvgIcCheck;
